import { motion } from "framer-motion";

// Fades content in and lifts it up on scroll into view.
// Cheap wrapper around framer-motion so pages stay clean.
export const FadeUp = ({ children, delay = 0, y = 24, className, once = true, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const StaggerChildren = ({ children, className, delayChildren = 0, stagger = 0.08 }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    variants={{ hidden: {}, visible: { transition: { delayChildren, staggerChildren: stagger } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, y = 24, className, ...rest }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
    }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);
